import { useNavigate } from "react-router-dom";

/**
 * @description - custom hook to replace deprecated replace property was in useHistory hook
 * @author Yasith Abeyratne<yasithab@unicorn-solutions.com>
 * @since 22/05/2025
 */

export const useReplaceNavigate = () => {
  const navigate = useNavigate();

  return ({
    path,
    searchParams,
    state,
  }: {
    path?: string;
    searchParams?: Record<string, string | null | undefined> | string;
    state?: any;
  }) => {
    let search = "";

    if (typeof searchParams === "string") {
      // If searchParams is already a string, use it directly
      search = searchParams;
    } else if (searchParams) {
      // If searchParams is an object, clean and encode it
      const cleanedParams: Record<string, string> = {};
      Object.entries(searchParams).forEach(([key, value]) => {
        if (value != null) {
          cleanedParams[key] = value;
        }
      });
      search = new URLSearchParams(cleanedParams).toString();
    }

    navigate({ pathname: path ?? location.pathname, search }, { replace: true, state });
  };
};